import { StringFilter } from '../../__generated__/graphql';
import createStringFilter from './createStringFilter';

export default function transformStringFilter(key: string): StringFilter {
  return createStringFilter(key);
}
